export class FileContentModel {
  fileUrl!: string;
  fileFound? = true;
  previewFileType!: PreviewFileTypes;
}

export enum PreviewFileTypes {
  unsupported,
  pdf,
  image,
  doc,
  ppt
}
